<script setup lang="ts">
type ApplicationData = App.Students.Data.ApplicationData;

import { ButtonSize } from '@/hooks/useButtonClasses';

import { useChatBot } from '@/domains/chat/composables/useChatBot';

import Button from '@/components/button/Button.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import SubmissionCardsList from '@/components/studentParentApp/SubmissionCardsList.vue';

import Plus from '@/icons/line/plus.svg';

defineProps<{
  applications: ApplicationData[];
}>();

const { enableChatBotForStudents } = useChatBot();

const { show, closeLocally } = useDialog();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    title="Submit College Application Information"
    :isOpen="show"
    fit="fill"
    @onClose="closeLocally"
    :showAiAdviser="enableChatBotForStudents"
  >
    <template #form>
      <SubmissionCardsList
        :items="applications"
        type="application"
        title="Existing College Applications"
      />
    </template>
    <template #footer>
      <div class="border-t border-slate-300 px-5 py-3.5">
        <Button
          class="w-full"
          :href="route('student.data-requests.create-college-application.create')"
          :size="ButtonSize.lg"
          :iconLeft="Plus"
          >Add College Application</Button
        >
      </div>
    </template>
  </Dialog>
</template>
